module.exports = __webpack_public_path__ + "static/media/bindOutlook1.69b44238.png";